<template>
  <div class="home">
    <header class="header">
      <span class="back">
        <svg-icon icon-class="arrow-icon" class-name="arrow-icon"></svg-icon>
      </span>
      <span class="headertitle">个人评估</span>
      <span></span>
    </header>
    <main class="main">
      <div class="studydatabox">
        <p class="title">Hi, 这是你的学习数据</p>
        <div class="studytime">
          <span class="studytitle">累计学习时长</span>
          <span class="studynum"><b class="num">{{AllLearnedData.totalLearnTime || 0}}</b>小时</span>
        </div>
        <div class="line"></div>
        <ul>
          <li>
            <p><b>{{AllLearnedData.todayLearnTime || 0}}</b></p>
            <p>今天学习</p>
          </li>
          <li>
            <p><b>{{AllLearnedData.lastWeekLearnTime || 0}}</b></p>
            <p>上周学习</p>
          </li>
          <li>
            <p><b>{{AllLearnedData.lastMonthLearnTime || 0}}</b></p>
            <p>上月学习</p>
          </li>
        </ul>
      </div>
      <div class="xunlianyin">
        <div class="xunlianyintitle">
          <span class="title">您参加的训练营</span>
        </div>
        <ul>
          <li>
            <p><b>{{TrainCampData.allTrainCount || 0}}</b></p>
            <p>全部</p>
          </li>
          <li>
            <p><b>{{TrainCampData.notStartTrainCount || 0}}</b></p>
            <p>未开始</p>
          </li>
          <li>
            <p><b>{{TrainCampData.runningTrainCount || 0}}</b></p>
            <p>进行中</p>
          </li>
          <li>
            <p><b>{{TrainCampData.finishedTrainCount || 0}}</b></p>
            <p>已完成</p>
          </li>
          <li>
            <p><b>{{TrainCampData.allTrainCount || 0}}</b></p>
            <p>未完成</p>
          </li>
        </ul>
      </div>
    </main>
    <footer class="footer"></footer>
  </div>
</template>
<script>
export default {
  name: "assessment",
  data(){
    return{
        AllLearnedData:'',
        TrainCampData:'',
    }
  },
  methods:{
      getAllLearnedData() {
       const params = {}
       const data = {}
       this.$api.myassessment.getAllLearnedData({ params, data }).then(res => {
         this.AllLearnedData = res.data;
      })
    },
    getAllTrainCampData() {
       const params = {}
       const data = {}
       this.$api.myassessment.getAllTrainCampData({ params, data }).then(res => {
         this.TrainCampData = res.data;
      })
    }
    //  async getAllLearnedData() {
    //    const params = {}
    //    const data = {}
    //   const Learned = await this.$api.myassessment.getAllLearnedData({ params, data }).then(res => {
    //     return res
    //   });
    //   console.debug(Learned, 'Learned')
    // },
  },
mounted(){
    this.getAllLearnedData();
    this.getAllTrainCampData();
  }
};
</script>
<style lang="less" scoped src="../asset/css/index.less">

</style>